import { render, staticRenderFns } from "./newsCont.vue?vue&type=template&id=867e785e&"
import script from "./newsCont.vue?vue&type=script&lang=js&"
export * from "./newsCont.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports